import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import Brokers from "@/pages/Brokers";
import BrokerDetail from "@/pages/BrokerDetail";
import Items from "@/pages/Items";
import Orders from "@/pages/Orders";
import OrderCreate from "@/pages/OrderCreate";
import OrderDetail from "@/pages/OrderDetail";
import Payments from "@/pages/Payments";
import Ledger from "@/pages/Ledger";
import TaxReport from "@/pages/TaxReport";
import Users from "@/pages/Users";
import Activity from "@/pages/Activity";
import Settings from "@/pages/Settings";
import AIAssistant from "@/pages/AIAssistant";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={<ProtectedRoute><Layout /></ProtectedRoute>}
          >
            <Route index element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:id" element={<CustomerDetail />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="suppliers/:id" element={<SupplierDetail />} />
            <Route path="brokers" element={<ProtectedRoute roles={["admin", "super_admin", "accounts", "operations"]}><Brokers /></ProtectedRoute>} />
            <Route path="brokers/:id" element={<ProtectedRoute roles={["admin", "super_admin", "accounts", "operations"]}><BrokerDetail /></ProtectedRoute>} />
            <Route path="items" element={<Items />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/new" element={<OrderCreate />} />
            <Route path="orders/:id/edit" element={<OrderCreate />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="payments" element={<ProtectedRoute roles={["admin", "accounts"]}><Payments /></ProtectedRoute>} />
            <Route path="ledger" element={<ProtectedRoute roles={["admin", "accounts"]}><Ledger /></ProtectedRoute>} />
            <Route path="tax" element={<ProtectedRoute roles={["admin", "accounts"]}><TaxReport /></ProtectedRoute>} />
            <Route path="ai" element={<AIAssistant />} />
            <Route path="users" element={<ProtectedRoute roles={["admin", "super_admin"]}><Users /></ProtectedRoute>} />
            <Route path="activity" element={<ProtectedRoute roles={["admin", "super_admin"]}><Activity /></ProtectedRoute>} />
            <Route path="settings" element={<ProtectedRoute roles={["admin", "super_admin"]}><Settings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
